import { QueryClient } from '@tanstack/react-query';
import { TeamsCacheKey, TIMES_CACHE } from '../constants/keyCache';

export const queryClient = new QueryClient();

queryClient.setQueryDefaults(TeamsCacheKey, {
  staleTime: TIMES_CACHE.DEFAULT_STALE_TIME,
  gcTime: TIMES_CACHE.DEFAULT_CACHE_TIME,
});
